import { showNotification as logNotification } from '@utils/helpers';

class NotificationManager {
  constructor() {
    this.notifications = [];
    this.container = null;
    this.isInitialized = false;
  }

  init() {
    if (this.isInitialized) return;
    
    // Create notification container
    this.container = document.createElement('div');
    this.container.id = 'notifications-container';
    this.container.className = 'notifications-container';
    
    document.body.appendChild(this.container);
    this.isInitialized = true;
    logNotification('Notification system initialized', 'info');
  }

  show(message, type = 'info', duration = 5000) {
    if (!this.isInitialized) {
      console.warn('Notification system not initialized');
      return null;
    }

    const id = `notification-${Date.now()}`;
    const notification = document.createElement('div');
    notification.id = id;
    notification.className = `notification notification-${type}`;

    notification.innerHTML = `
      <div class="notification-content">
        <div class="notification-message">${message}</div>
        <button class="notification-close">×</button>
      </div>
      <div class="notification-progress"></div>
    `;

    // Add to container
    this.container.appendChild(notification);
    
    // Trigger animation
    requestAnimationFrame(() => {
      notification.style.transform = 'translateX(0)';
      notification.querySelector('.notification-progress').style.transform = 'scaleX(0)';
    });

    // Auto-remove notification
    const removeTimeout = setTimeout(() => {
      this._removeNotification(id);
    }, duration);

    // Close button handler
    const closeButton = notification.querySelector('.notification-close');
    closeButton.addEventListener('click', () => {
      clearTimeout(removeTimeout);
      this._removeNotification(id);
    });

    // Store notification data
    const notificationData = {
      id,
      element: notification,
      removeTimeout,
      createdAt: Date.now()
    };

    this.notifications.push(notificationData);
    return notificationData;
  }

  _removeNotification(id) {
    const index = this.notifications.findIndex(n => n.id === id);
    if (index === -1) return;

    const [notification] = this.notifications.splice(index, 1);
    notification.element.style.transform = 'translateX(120%)';
    
    // Remove from DOM after animation
    setTimeout(() => {
      if (notification.element.parentNode) {
        notification.element.parentNode.removeChild(notification.element);
      }
    }, 300);
  }

  cleanup() {
    if (this.container && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
    this.notifications.forEach(notification => {
      clearTimeout(notification.removeTimeout);
    });
    this.notifications = [];
    this.isInitialized = false;
  }
}

// Export a singleton instance
export const notificationManager = new NotificationManager();

// For backward compatibility
export const showNotification = (message, type = 'info', duration = 5000) => {
  return notificationManager.show(message, type, duration);
};

export default NotificationManager; 